import { render, staticRenderFns } from "./AulaProfileFrame.vue?vue&type=template&id=2079b35b&scoped=true&"
import script from "./AulaProfileFrame.vue?vue&type=script&lang=js&"
export * from "./AulaProfileFrame.vue?vue&type=script&lang=js&"
import style0 from "./AulaProfileFrame.vue?vue&type=style&index=0&id=2079b35b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079b35b",
  null
  
)

export default component.exports